import {
	ORDER_NOTIFICATIONS_SET,
	ORDER_NOTIFICATIONS_MARK_READ,
	ORDER_NOTIFICATIONS_MARK_ALL_READ,
	ORDER_NOTIFICATIONS_SET_FILTER,
	ORDER_NOTIFICATIONS_TOGGLE_UNREAD,
	ORDER_NOTIFICATIONS_SET_LOADING,
	ORDER_NOTIFICATIONS_OPEN_DRAWER,
	ORDER_NOTIFICATIONS_CLOSE_DRAWER,
	ORDER_NOTIFICATIONS_ADD,
	ORDER_NOTIFICATIONS_UPDATE,
	ORDER_NOTIFICATIONS_SHOW_TOAST,
	ORDER_NOTIFICATIONS_HIDE_TOAST,
	USER_LOGOUT,
} from 'src/actions/reduxConstants';
import { OrderNotification, NotificationFilter } from 'src/screens/Home/NotificationsDrawer/types';

interface NotificationToastState {
	open: boolean;
	id: string;
	notification_type: string;
	entity_id?: string;
	system_id?: string | null;
	meta?: OrderNotification['meta'];
	created_at: string;
}

interface OrderNotificationsState {
	items: OrderNotification[];
	loading: boolean;
	filter: NotificationFilter;
	unread_only: boolean;
	drawer_open: boolean;
	toast_notification: NotificationToastState | null;
}

const initial_state: OrderNotificationsState = {
	items: [],
	loading: false,
	filter: 'all',
	unread_only: false,
	drawer_open: false,
	toast_notification: null,
};

const order_notifications_reducer = (state = initial_state, action: any): OrderNotificationsState => {
	switch (action.type) {
		case ORDER_NOTIFICATIONS_SET:
			return { ...state, items: action.payload };

		case ORDER_NOTIFICATIONS_ADD: {
			const already_exists = state.items.some((n) => n.id === action.payload.id);
			if (already_exists) return state;
			return { ...state, items: [action.payload, ...state.items] };
		}

		case ORDER_NOTIFICATIONS_UPDATE: {
			const updated: OrderNotification = action.payload;
			if (updated?.is_dismissed) {
				return { ...state, items: state.items.filter((n) => n.id !== updated.id) };
			}
			return {
				...state,
				items: state.items.map((n) => (n.id === updated.id ? updated : n)),
			};
		}

		case ORDER_NOTIFICATIONS_MARK_READ:
			return {
				...state,
				items: state.items.map((n) => (n.id === action.payload ? { ...n, is_read: true } : n)),
			};

		case ORDER_NOTIFICATIONS_MARK_ALL_READ:
			return { ...state, items: state.items.map((n) => ({ ...n, is_read: true })) };

		case ORDER_NOTIFICATIONS_SET_FILTER:
			return { ...state, filter: action.payload };

		case ORDER_NOTIFICATIONS_TOGGLE_UNREAD:
			return { ...state, unread_only: !state.unread_only };

		case ORDER_NOTIFICATIONS_SET_LOADING:
			return { ...state, loading: action.payload };

		case ORDER_NOTIFICATIONS_OPEN_DRAWER:
			return { ...state, drawer_open: true };

		case ORDER_NOTIFICATIONS_CLOSE_DRAWER:
			return { ...state, drawer_open: false };

		case ORDER_NOTIFICATIONS_SHOW_TOAST:
			return { ...state, toast_notification: { open: true, ...action.payload } };

		case ORDER_NOTIFICATIONS_HIDE_TOAST:
			return { ...state, toast_notification: null };

		case USER_LOGOUT:
			return { ...initial_state };

		default:
			return state;
	}
};

export default order_notifications_reducer;
